export enum Banks {
	Bank1 = -1,
	Bank2 = -2,
	Bank3 = -3,
	Bank4 = -4,
	Bank5 = -5
}